import { createContext } from 'react';

const GuestViewContext = createContext(null);

export default GuestViewContext;
